import React from 'react'

const MissionVisionValue = () => {
    const MissionVisionObj = [
    {
        id:1,
        img:"assets/new-images/about-us/visiion.webp",
        heading:"Our Vision",
        para:"Alobha technologies is one of the protuberant software development companies that transform other businesses by innovatively connecting dots from design to development. It differentiates you from the market and provides healthier engagement with clienteles & partners.",
        class:"serviceBox saf",
    },
    {
        id:2,
        img:"assets/new-images/about-us/mission.webp",
        heading:"Our Mission",
        para:"Our mission is to augment business growth of our clients with creative design & Development to deliver their idea with high quality solutions which transform data into knowledge across the globe.",
        class:"serviceBox green",
    },
    {
        id:3,
        img:"assets/new-images/about-us/value-2.webp",
        heading:"Our Value",
        para:"Great builds come from organized teams that are responsible for themselves. We Focus on the client requirements and all else will follow. It’s best to do one thing really, really well. Integrity, Boldness and Honesty are our three pillars.",
        class:"serviceBox orange",
    },
    ];
    return (
        <>
            <section className="mission-vision-val-section">
                <div className="container">
                    <div className="row">
                        {MissionVisionObj.map((Mcard) => {
                            return <div className="col-lg-4 col-md-6 col-sm-12" key={Mcard.id}>
                            <div className={Mcard.class}>
                                <div className="service-icon">
                                    <img src={Mcard.img} alt="" loading="lazy" />
                                </div>
                                <h3 className="title">{Mcard.heading}</h3>
                                <p className="description">{Mcard.para}</p>
                            </div>
                        </div>
                        })}
                    </div>
                </div>
            </section>
        </>
    )
}

export default MissionVisionValue